import { showLogin, takeLoginToken } from './ui/login';
import { applyPreferences } from './ui/preferences';

applyPreferences();
const viewport = () => document.documentElement.style.setProperty('--view-height', `${window.visualViewport?.height ?? innerHeight}px`);
viewport();
window.visualViewport?.addEventListener('resize', viewport);
window.addEventListener('resize', viewport);

const params = new URLSearchParams(location.search);
if (params.get('local') !== '1' && params.get('autopilot') !== '1' && !takeLoginToken()) {
  showLogin();
} else {
  const loading = document.getElementById('loading')!;
  loading.hidden = false;
  try {
    await import('./main');
    loading.remove();
  } catch (e) {
    console.error(e);
    loading.innerHTML = '<h1>Unable to start Wavesworn</h1><p>Check your connection and that your browser supports hardware graphics, then try again.</p><button type="button">Try again</button>';
    loading.querySelector('button')!.onclick = () => location.reload();
  }
}
